import type { VoidFunctionComponent } from 'react';

import { Divider } from '../../generic/Divider';
import { FormatSelector } from '../components/FormatSelector';
import { Heading } from '../components/Heading';
import PreviewFiltersLayout from '../layout/PreviewFiltersLayout';

import { RemediationGenerateButton } from './RemediationGenerateButton';
import { RemediationGuidanceOptions } from './RemediationGuidanceOptions';
import { RemediationGuidancePreview } from './RemediationGuidancePreview';

/**
 * Dedicated page component for the Remediation Guidance report.
 * Unlike the standard ReportsV3Page, this has:
 * - No flow selector (Standard/Custom)
 * - No step headings
 * - No blurb section
 * - Direct preview + filters layout
 */
export const RemediationGuidancePage: VoidFunctionComponent = () => (
  <main className="padding-left-sm">
    <Heading />
    <PreviewFiltersLayout>
      <PreviewFiltersLayout.Preview>
        <RemediationGuidancePreview />
      </PreviewFiltersLayout.Preview>
      <PreviewFiltersLayout.Filters>
        <div>
          <FormatSelector />
          <RemediationGenerateButton />
        </div>
        <Divider />
        <RemediationGuidanceOptions />
      </PreviewFiltersLayout.Filters>
    </PreviewFiltersLayout>
  </main>
);
